import './VerticalSlider.css';

interface VerticalSliderProps {
  value: number;
  min: number;
  max: number;
  step?: number;
  topLabel: string;
  bottomLabel: string;
  onChange: (value: number) => void;
}

export function VerticalSlider({
  value,
  min,
  max,
  step = 1,
  topLabel,
  bottomLabel,
  onChange,
}: VerticalSliderProps) {
  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className="vertical-slider">
      <span className="slider-label top">{topLabel}</span>
      
      <div className="slider-track-container">
        <div className="slider-track">
          <div 
            className="slider-fill" 
            style={{ height: `${percentage}%` }}
          />
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
            className="slider-input"
          />
          <div 
            className="slider-thumb"
            style={{ bottom: `${percentage}%` }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 10l5-5 5 5H7zm0 4l5 5 5-5H7z" />
            </svg>
          </div>
        </div>
      </div>
      
      <span className="slider-label bottom">{bottomLabel}</span>
    </div>
  );
}







